import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Represents Contact Us.
 * @author kkum
 */import React, { Component } from 'react';
// import styled from 'styled-components';
import { formLabels, formErrorMessages } from '../../../constants/labels/en';
import analyticsConstants from '../../../constants/analyticsConstants';
// import ReCaptcha from '../../molecules/ReCaptcha';
// import { formsCaptchaActions } from '../../../constants/globalConstants';
import parse, { domToReact } from 'html-react-parser';
// import Form from '../../molecules/Form';
// import Checkbox from '../../molecules/Form/FieldCheckbox';
import Button from '../../atoms/Button';
import Heading from '../../atoms/Heading';
import { sendEmail } from '../../../utils/formUtility';
// const camelCase = require('camelcase');
import styled from 'styled-components';
import styles from './FormKeep.style';
var FormKeepStyles = styled.section.withConfig({
  componentId: "sc-1e3qabv-0"
})(["", ";"], styles);
var FormKeep = /*#__PURE__*/function (_Component) {
  _inherits(FormKeep, _Component);
  var _super = _createSuper(FormKeep);
  function FormKeep(props) {
    var _this;
    _classCallCheck(this, FormKeep);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (e) {
      e.preventDefault();
      var values = _this.serialize(e.target);
      var action = _this.state.action;
      _this.setState({
        isSubmitting: true
      });
      sendEmail(values, action,
      // this.state.captchaToken,
      _this.failureCallback, _this.successCallback);
    });
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.successCallback = _this.successCallback.bind(_assertThisInitialized(_this));
    _this.failureCallback = _this.failureCallback.bind(_assertThisInitialized(_this));
    _this.serialize = _this.serialize.bind(_assertThisInitialized(_this));
    // this.saveCaptchaToken = this.saveCaptchaToken.bind(this);
    _this.state = {
      isSuccessfulSubmission: false,
      errorEmailSending: false,
      isSubmitting: false,
      captchaToken: '',
      action: _this.props.bookFormData.submitUrl
    };
    return _this;
  }
  _createClass(FormKeep, [{
    key: "successCallback",
    value: function successCallback() {
      this.setState({
        isSuccessfulSubmission: true,
        isSubmitting: true
      });
    }
  }, {
    key: "failureCallback",
    value: function failureCallback() {
      this.setState({
        errorEmailSending: true,
        isSubmitting: false
      });
    }
  }, {
    key: "serialize",
    value: function serialize(form) {
      var field,
        s = [];
      if (typeof form == 'object' && form.nodeName == 'FORM') {
        var len = form.elements.length;
        for (var i = 0; i < len; i++) {
          field = form.elements[i];
          if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
            if (field.type == 'select-multiple') {
              for (var j = form.elements[i].options.length - 1; j >= 0; j--) {
                if (field.options[j].selected) s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[j].value);
              }
            } else if (field.type != 'checkbox' && field.type != 'radio' || field.checked) {
              s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value);
            }
          }
        }
      }
      return s.join('&').replace(/%20/g, '+');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var html = this.props.formkeepTest;
      // var validationFields = [];
      var initialValues = {};
      var options = {
        replace: function replace(_ref) {
          var attribs = _ref.attribs,
            children = _ref.children;
          if (!attribs) return;
          if (attribs.type === 'submit') {
            return __jsx(Button, {
              styleType: "primary",
              className: "nva-form-keep__button ".concat(_this2.state.isSubmitting ? 'nva-form-keep__button--btn-success btn-success' : 'nva-form-keep__button--primary primary'),
              disabled: _this2.state.isSubmitting,
              type: "submit",
              "data-analytics-type": analyticsConstants.contactUs.analyticsType.CONTACT_FORM_TYPE,
              "data-analytics-value": analyticsConstants.contactUs.analyticsValue.CONTACT_FORM_VALUE,
              "data-analytics-variation": ""
            }, attribs.title || formLabels.contactUsForm.SUBMIT_BUTTON);
          }
          if (attribs.method === 'POST') {
            var formAction = attribs.action;
            Object.assign(initialValues, {
              action: formAction
            });
            var userFormProps = {
              action: formAction,
              method: 'POST',
              acceptCharset: 'UTF-8'
            };
            return __jsx(FormKeepStyles, null, __jsx("form", _extends({}, userFormProps, {
              onSubmit: _this2.handleSubmit,
              className: "nva-form-keep__form"
            }), __jsx("div", null, __jsx("div", null, domToReact(children, options)))));
          }
        }
      };
      if (this.state.isSuccessfulSubmission) {
        return __jsx(FormKeepStyles, null, __jsx("div", {
          className: "nva-form-keep__success-message ".concat(this.props.className),
          id: "submit-response"
        }, __jsx(Heading, {
          HeadingType: "h3",
          className: "success-message"
        }, this.props.bookFormData.successfulSubmissionMessage)));
      }
      if (this.state.errorEmailSending) {
        return __jsx(FormKeepStyles, null, __jsx("div", {
          className: "nva-form-keep__error-message ".concat(this.props.className),
          id: "submit-response"
        }, __jsx(Heading, {
          HeadingType: "h4",
          className: "error-message"
        }, formErrorMessages.contactUsForm.EMAIL_SEND_ERROR)));
      }
      return parse(html, options);
    }
  }]);
  return FormKeep;
}(Component);
FormKeep.defaultProps = {
  className: ''
};
export default styled(FormKeep).withConfig({
  componentId: "sc-1e3qabv-1"
})(["", ";"], styles);

// /**
//  * Represents Contact Us.
//  * @author kkum
//  */
// // 
// import React, { Component, Fragment } from 'react';
// // import styled from 'styled-components';
// import { formLabels, formErrorMessages } from '../../../constants/labels/en';
// import analyticsConstants from '../../../constants/analyticsConstants';
// import Heading from '../../atoms/Heading';
// import { sendEmail } from '../../../utils/formUtility';
// import styled from 'styled-components';
// import styles from './FormKeep.style';
// import parse, { domToReact } from 'html-react-parser';
// import Button from '../../atoms/Button';

// const FormKeepStyles = styled.section`
//   ${styles};
// `;

// type Props = {
//   className: string,
//   bookFormData: Object,
//   formkeepTest: Object
// };

// class FormKeep extends Component<Props> {
//   constructor(props) {
//     super(props);
//     this.handleSubmit = this.handleSubmit.bind(this);
//     this.successCallback = this.successCallback.bind(this);
//     this.failureCallback = this.failureCallback.bind(this);
//     // this.saveCaptchaToken = this.saveCaptchaToken.bind(this);

//     this.state = {
//       isSuccessfulSubmission: false,
//       errorEmailSending: false,
//       captchaToken: ''
//     };
//   }

//   // saveCaptchaToken(captchaToken) {
//   //   this.setState(() => ({ captchaToken }));
//   // }

//   successCallback() {
//     this.setState({
//       isSuccessfulSubmission: true
//     });
//   }

//   failureCallback() {
//     this.setState({
//       errorEmailSending: true
//     });
//   }

//   handleSubmit(values) {
//     sendEmail(
//       values,
//       // this.state.captchaToken,
//       this.failureCallback,
//       this.successCallback
//     );
//   }

//   render() {
//     const html = this.props.formkeepTest;

//     const options = {
//       replace: ({ attribs, children }) => {
//         if (!attribs) return;

//console.log(attribs)
//         if (attribs.type === 'submit') {
//           return (

//             <Button
//               onClick={this.handleSubmit}
//               styleType="primary"
//               type="submit"
//               data-analytics-type={
//                 analyticsConstants.contactUs.analyticsType
//                   .CONTACT_FORM_TYPE
//               }
//               data-analytics-value={
//                 analyticsConstants.contactUs.analyticsValue
//                   .CONTACT_FORM_VALUE
//               }
//               data-analytics-variation=""
//             >
//               text
//             </Button>
//           )
//         }

//         if (attribs.method === 'POST') {

//         return (
//           <FormKeepStyles>
//             <div>
//             <div dangerouslySetInnerHTML={{ __html: html }} />
//           </div>
//           </FormKeepStyles>
//         );
//             }

//       }
//     }
//     if (this.state.isSuccessfulSubmission) {
//       return (
//         <FormKeepStyles>
//           <div className={this.props.className} id="submit-response">
//             <Heading HeadingType="h2" className="form-heading">
//               {formLabels.contactUsForm.FORM_HEADING}
//             </Heading>
//             <Heading HeadingType="h3" className="success-message">
//               {this.props.bookFormData.successfulSubmissionMessage}
//             </Heading>
//           </div>
//         </FormKeepStyles>
//       );
//     }
//     if (this.state.errorEmailSending) {
//       return (
//         <FormKeepStyles>
//           <div className={this.props.className} id="submit-response">
//             <Heading HeadingType="h4" className="error-message">
//               {formErrorMessages.contactUsForm.EMAIL_SEND_ERROR}
//             </Heading>
//           </div>
//         </FormKeepStyles>
//       );
//     }
//     return parse(html, options);

//   }
// }
// FormKeep.defaultProps = {
//   className: ''
// };
// export default styled(FormKeep)`
//   ${styles};
// `;